module.exports = __webpack_public_path__ + "img/st-regis-maldvies_0.e51000ac.jpg";